import { CompletionView } from './components/features/CompletionView';
import { Header } from './components/features/Header';
import { IdleView } from './components/features/IdleView';
import { ProgressView } from './components/features/ProgressView';
import { useAutomationBridge } from './hooks/useAutomationBridge';
import { useAppStore } from './stores/useAppStore';

export default function App(): JSX.Element {
  // 外部ツール（Claude Code 等）から window.__hitopAuto で自動操作する用の
  // ブリッジ。UI / UX は完全に不変。詳細は src/lib/automation.ts 参照。
  useAutomationBridge();

  const phase = useAppStore((s) => s.phase);
  const reset = useAppStore((s) => s.reset);

  if (phase.kind === 'processing') {
    return (
      <AppShell>
        <ProgressView phase={phase} />
      </AppShell>
    );
  }

  if (phase.kind === 'done') {
    return (
      <AppShell>
        <CompletionView
          zipBlob={phase.zipBlob}
          zipName={phase.zipName}
          summary={phase.summary}
          onReset={reset}
        />
      </AppShell>
    );
  }

  return (
    <AppShell>
      <IdleView />
    </AppShell>
  );
}

function AppShell(props: { readonly children: React.ReactNode }): JSX.Element {
  return (
    <div className="bg-bg-primary min-h-screen">
      <Header />
      <main className="mx-auto max-w-6xl px-6 py-8">{props.children}</main>
    </div>
  );
}
